
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "./style.css";



import { io } from 'socket.io-client';
import { createApp, watch } from "vue";
import App from "./App.vue";
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';
import AnimateOnScroll from 'primevue/animateonscroll';
import Avatar from 'primevue/avatar';
import Badge from 'primevue/badge';
import BadgeDirective from "primevue/badgedirective";
import Button from 'primevue/button';
import Card from 'primevue/card';
import Chips from 'primevue/chips';
import Checkbox from 'primevue/checkbox';
import Column from 'primevue/column';
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmationService from 'primevue/confirmationservice';
import DataTable from 'primevue/datatable';
import Dialog from 'primevue/dialog';
import Drawer from 'primevue/drawer';

import DialogService from 'primevue/dialogservice'
import FileUpload from 'primevue/fileupload';
import FocusTrap from 'primevue/focustrap';
import Galleria from 'primevue/galleria';
import Image from 'primevue/image';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import InputNumber from 'primevue/inputnumber';
import InputText from 'primevue/inputtext';
import Menu from 'primevue/menu';
import MultiSelect from 'primevue/multiselect';
import Popover from 'primevue/popover';
import Ripple from 'primevue/ripple';
import Sidebar from 'primevue/sidebar';
import StyleClass from 'primevue/styleclass';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import Textarea from 'primevue/textarea';
import Tooltip from 'primevue/tooltip';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Editor from 'primevue/editor';
import ProgressSpinner from 'primevue/progressspinner'
import ConfirmPopup from 'primevue/confirmpopup'
import Carousel from 'primevue/carousel'
import TabMenu from 'primevue/tabmenu'
import AutoComplete from 'primevue/autocomplete'
import Dropdown from 'primevue/dropdown'
import Message from "primevue/message";
import Select from "primevue/select";
import RadioButton from "primevue/radiobutton";
import Chip from "primevue/chip";
import AvatarGroup from "primevue/avatargroup";
import Password from "primevue/password";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import ContextMenu from "primevue/contextmenu";
import { initLocale } from './i18n';
import GlobalUtils from './utils/utils';


import PrimeVue from 'primevue/config';
import Lara from '@primevue/themes/lara';
import ToggleSwitch from 'primevue/toggleswitch';

async function bootstrap() {
    const i18n = await initLocale();
    const app = createApp(App);
    const socket_url = window.easychatrooms.EASYCHAT_APP_SOCKET_URL || 'https://demo-servers.easychatrooms.com';
    const socket = io(socket_url, {
        autoConnect: false,
        reconnection: false
    });
    GlobalUtils.url = socket_url;
    app.config.globalProperties.$utils = GlobalUtils;
    app.config.globalProperties.$socket = socket;
    app.config.globalProperties.$socket_url = socket_url;
    app.use(i18n);
    app.use(PrimeVue, {
        theme: {
            preset: Lara,
            options: {
                prefix: 'p',
                darkModeSelector: '.p-dark',
                cssLayer: false
            }
        }
    });


    watch(
        () => i18n.global.locale,
        (newLocale) => {
            app.config.globalProperties.$primevue.config.rtl = newLocale === 'ar';
        }
    );






    app.use(ConfirmationService);
    app.use(ToastService);
    app.use(DialogService);


    app.directive('tooltip', Tooltip);
    app.directive('badge', BadgeDirective);
    app.directive('ripple', Ripple);
    app.directive('styleclass', StyleClass);
    app.directive('focustrap', FocusTrap);
    app.directive('animateonscroll', AnimateOnScroll);




    app.component('Editor', Editor);
    app.component('Accordion', Accordion);
    app.component('AccordionPanel', AccordionPanel);
    app.component('AccordionHeader', AccordionHeader);
    app.component('AccordionContent', AccordionContent);
    app.component('Avatar', Avatar);
    app.component('Badge', Badge);
    app.component('Button', Button);
    app.component('Card', Card);
    app.component('Chips', Chips);
    app.component('Checkbox', Checkbox);
    app.component('Column', Column);
    app.component('ConfirmDialog', ConfirmDialog);
    app.component('DataTable', DataTable);
    app.component('DataView', DataView);
    app.component('Dialog', Dialog);
    app.component('Drawer', Drawer);
    app.component('FileUpload', FileUpload);
    app.component('Galleria', Galleria);
    app.component('Image', Image);
    app.component('InputGroup', InputGroup);
    app.component('InputGroupAddon', InputGroupAddon);
    app.component('InputNumber', InputNumber);
    app.component('InputText', InputText);
    app.component('Menu', Menu);
    app.component('MultiSelect', MultiSelect);
    app.component('Popover', Popover);
    app.component('Sidebar', Sidebar);
    app.component('Tabs', Tabs);
    app.component('TabList', TabList);
    app.component('Tab', Tab);
    app.component('Textarea', Textarea);
    app.component('Toast', Toast);
    app.component('ProgressSpinner', ProgressSpinner);
    app.component('ConfirmPopup', ConfirmPopup);

    app.component('Carousel', Carousel);
    app.component('TabMenu', TabMenu);
    app.component('AutoComplete', AutoComplete);
    app.component('Dropdown', Dropdown);
    app.component('Message', Message);
    app.component('Select', Select);
    app.component('RadioButton', RadioButton);
    app.component('Chip', Chip);
    app.component('AvatarGroup', AvatarGroup);
    app.component('Password', Password);
    app.component('TabView', TabView);
    app.component('TabPanel', TabPanel);
    app.component('ContextMenu', ContextMenu);
    app.component('ToggleSwitch', ToggleSwitch);

    app.mount("#app");
}

bootstrap();